import { render, staticRenderFns } from "./PacienteEsperaCard.vue?vue&type=template&id=ac9ef32e&scoped=true"
import script from "./PacienteEsperaCard.vue?vue&type=script&lang=js"
export * from "./PacienteEsperaCard.vue?vue&type=script&lang=js"
import style0 from "./PacienteEsperaCard.vue?vue&type=style&index=0&id=ac9ef32e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9ef32e",
  null
  
)

export default component.exports